import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { SurfaceHeader } from '@frontend/surface-header';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';

interface Props {
  appointmentsInfoText: string;
  providerName: string;
}

export const PanelHeader = ({ appointmentsInfoText, providerName }: Props) => {
  const { t } = useTranslation('schedule');

  return (
    <SurfaceHeader.Root>
      <SurfaceHeader.Row>
        <SurfaceHeader.Title>{t('Overlapping Appointments')}</SurfaceHeader.Title>
      </SurfaceHeader.Row>
      <SurfaceHeader.Body>
        <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
          <Icon name='calendar-small' color='light' />
          <Text size='medium' color='light'>
            {appointmentsInfoText}
          </Text>
        </div>
        <div css={{ display: 'flex', alignItems: 'center', gap: theme.spacing(1) }}>
          <Icon name='user-small' color='subdued' />
          <Text size='medium' color='subdued'>
            {providerName}
          </Text>
        </div>
      </SurfaceHeader.Body>
    </SurfaceHeader.Root>
  );
};
